module.exports = __webpack_public_path__ + "static/media/back1-min.63db2aaa.jpg";